var currentContentSpotIndex = 0;
var nextContentSpotIndex = 4;

var currentContentSpotIndexMobile = 0;
var nextContentSpotIndexMobile = 4;

const buildContentSpot = (mutationRecord) => {
  if (contentSpots && currentContentSpotIndex < contentSpots.length) {
    const currentContentSpot = contentSpots[currentContentSpotIndex];
    const li = document.createElement('li');
    li.classList.add('grid__item');
    const div = document.createElement('div');
    div.className = 'ec-h-full ec-relative content-spot-container';
    const img = document.createElement('img');
    img.className = 'ec-object-cover ec-h-full ec-w-full';
    img.src = contentSpotImages[currentContentSpotIndex];
    img.srcset = `${contentSpotImages[currentContentSpotIndex]}&width=128 128w,${contentSpotImages[currentContentSpotIndex]}&width=256 256w, ${contentSpotImages[currentContentSpotIndex]}&width=600 600w`;
    const a = document.createElement('a');
    a.className =
      'content_spot content-spot-overlay ec-absolute ec-top-0 ec-left-0 ec-bottom-0 ec-right-0 ec-p-6 ec-no-underline';
    if (currentContentSpot.url) {
      a.href = currentContentSpot.url;
    }
    const span = document.createElement('span', {
      class: 'c-uppercase ec-font-semibold ec-text-2xl ec-text-white ec-leading-none',
    });
    span.className = 'ec-uppercase ec-font-semibold ec-text-2xl ec-text-white ec-leading-none';
    span.innerHTML = currentContentSpot.text;
    a.appendChild(span);
    div.appendChild(img);
    div.appendChild(a);
    li.appendChild(div);
    const parentElement = mutationRecord;
    const referenceElement = mutationRecord.children[nextContentSpotIndex];
    parentElement.insertBefore(li, referenceElement);
    nextContentSpotIndex = nextContentSpotIndex + 8;
    currentContentSpotIndex++;
  }
};

const buildContentSpotMobile = (mutationRecord) => {
  if (contentSpots && currentContentSpotIndexMobile < contentSpots.length) {
    const currentContentSpot = contentSpots[currentContentSpotIndexMobile];
    const li = document.createElement('li');
    li.classList.add('grid__item');
    const div = document.createElement('div');
    div.className = 'ec-h-full ec-relative';
    const img = document.createElement('img');
    img.className = 'ec-object-cover ec-h-full ec-w-full';
    img.src = contentSpotImages[currentContentSpotIndexMobile];
    img.srcset = `${contentSpotImages[currentContentSpotIndexMobile]}&width=128 128w,${contentSpotImages[currentContentSpotIndexMobile]}&width=256 256w, ${contentSpotImages[currentContentSpotIndexMobile]}&width=300 300w`;
    const a = document.createElement('a');
    a.className =
      'content_spot content-spot-overlay ec-absolute ec-top-0 ec-left-0 ec-bottom-0 ec-right-0 ec-p-6 ec-no-underline';
    if (currentContentSpot.url) {
      a.href = currentContentSpot.url;
    }
    const span = document.createElement('span', {
      class: 'c-uppercase ec-font-semibold ec-text-2xl ec-text-white ec-leading-none',
    });
    span.className = 'ec-uppercase ec-font-semibold ec-text-2xl ec-text-white ec-leading-none';
    span.innerHTML = currentContentSpot.text;
    a.appendChild(span);
    div.appendChild(img);
    div.appendChild(a);
    li.appendChild(div);
    const parentElement = mutationRecord;
    const referenceElement = mutationRecord.children[nextContentSpotIndexMobile];
    parentElement.insertBefore(li, referenceElement);
    nextContentSpotIndexMobile = nextContentSpotIndexMobile + 8;
    currentContentSpotIndexMobile++;
  }
};

const gridObserverTwo = new MutationObserver((mutationRecords) => {
  if (mutationRecords[0].addedNodes.length > 1) {
    buildContentSpot(mutationRecords[0].target);
    addVideoPlayListeners();
  }
});

// Select the element you want to watch
const gridElementNodeTwo = document.getElementById('product-grid');

if (gridElementNodeTwo) {
  // Call the observe function by passing the node you want to watch with configuration options
  gridObserverTwo.observe(gridElementNodeTwo, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
    characterDataOldValue: true,
  });
}

const ul = document.getElementById('product-grid');
const ulMobile = document.getElementById('product-grid-mobile');

buildContentSpot(ul);
buildContentSpot(ul);

buildContentSpotMobile(ulMobile);
buildContentSpotMobile(ulMobile);

const addVideoPlayListeners = () => {
  const cardWrapper = document.getElementsByClassName('product-card-wrapper');
  const cardWrapperArray = Array.from(cardWrapper);
  cardWrapperArray.forEach((cardWrapper) => {
    const card = cardWrapper.getElementsByClassName('card')[0];
    const cardInner = card.getElementsByClassName('card__inner')[0];
    const cardMedia = cardInner.getElementsByClassName('card__media')[0];
    if (cardMedia) {
      const media = cardMedia.getElementsByClassName('media')[0];
      secondChildren = media.children[1];
      if (secondChildren && secondChildren.className.includes('video')) {
        const videoTag = media.getElementsByTagName('video')[0];
        if (videoTag) {
          cardWrapper.addEventListener('mouseenter', (event) => {
            videoTag.play();
          });
          cardWrapper.addEventListener('mouseleave', (event) => {
            videoTag.pause();
          });
        }
      }
    }
  });
};

addVideoPlayListeners();

const addImageHoverListener = () => {
  const cardWrappers = document.querySelectorAll('.product-card-wrapper');

  cardWrappers.forEach((cardWrapper, index) => {
    const card = cardWrapper.querySelector('.card');
    const link = card?.querySelector('.ec-product-link');
    const cardInner = card?.querySelector('.card__inner');
    const cardMedia = cardInner?.querySelector('.card__media');
    const media = cardMedia?.querySelector('.media');

    if (link && media && media.children.length > 1) {
      const firstImage = media.children[0];
      const secondImage = media.children[1];

      link.addEventListener('mouseenter', () => {
        firstImage.style.opacity = '0';
        secondImage.style.opacity = '1';
      });

      link.addEventListener('mouseleave', () => {
        firstImage.style.opacity = '1';
        secondImage.style.opacity = '0';
      });

      firstImage.style.transition = 'opacity 0.2s ease-in-out';
      secondImage.style.transition = 'opacity 0.2s ease-in-out';
    }
  });
};

addImageHoverListener();

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

document.addEventListener('DOMContentLoaded', function () {
  if (collectionGender === 'men') {
    setCookie('gender', 'men', 1);
  }
  if (collectionGender === 'women') {
    setCookie('gender', 'women', 1);
  }
});
